import { useEffect, useState } from 'react';
import { getFavorites, removeFavorite } from '../../../../services/favoritesService';
import EmptyState from '../../../../Components/EmptyState/EmptyState';
import Toast from "../../../../Components/Toast/Toast";
import './Favorites.scss';

const Favorites = () => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);
  const [toast, setToast] = useState({ message: "", type: "success" });

  const showToast = (message, type = "success") => {
    setToast({ message, type });
  };

  const companyId = localStorage.getItem('userId');

  const fetchFavorites = async () => {
    try {
      setLoading(true);
      const data = await getFavorites(companyId);
      setFavorites(data);
    } catch (err) {
      // console.error('Erro ao carregar favoritos:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (companyId) fetchFavorites();
  }, [companyId]);

  const handleRemove = async (freelancerId) => {
    if (!confirm('Remover este freelancer dos favoritos?')) return;

    setBusyId(freelancerId);
    try {
      await removeFavorite(freelancerId);
      setFavorites(prev => prev.filter(f => f.freelancer.id !== freelancerId));
    } catch (err) {
      console.error('Erro ao remover favorito:', err);
      showToast('Erro ao remover favorito.', "errors");
    } finally {
      setBusyId(null);
    }
  };

  if (loading) {
    return <div className="fav-loading">Carregando favoritos...</div>;
  }

  if (favorites.length === 0) {
    return (
      <EmptyState message="Você ainda não tem freelancers favoritos. Favorite alguém na aba Finalizadas depois de concluir um trabalho." />
    );
  }

  return (
    <section className="fav-wrapper">
      <div className="fav-header">
        <h2 className="fav-title">Freelancers Favoritos</h2>
        <p className="fav-subtitle">
          Use essa lista para enviar convites diretos em vagas futuras.
        </p>
      </div>

      <div className="fav-grid">
        {favorites.map(({ id, freelancer }) => {
  const displayName = freelancer.nomeSocial?.trim() || freelancer.name;

  return (
    <div key={id} className="fav-card">
      {freelancer.avatarUrl ? (
        <img
          src={freelancer.avatarUrl}
          alt={displayName}
          className="fav-avatar"
        />
      ) : (
        <div className="fav-avatar-fallback">
          {displayName?.slice(0, 2).toUpperCase()}
        </div>
      )}

      <div className="fav-info">
        <p className="fav-name">{displayName}</p>

        {freelancer.phone && (
          <p className="fav-phone">{freelancer.phone}</p>
        )}
      </div>

      <button
        className="fav-btn fav-btn--remove"
        onClick={() => handleRemove(freelancer.id)}
        disabled={busyId === freelancer.id}
      >
        {busyId === freelancer.id ? "..." : "Remover"}
      </button>
    </div>
  );
})}
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ message: "", type: "success" })}
        />
      </div>
    </section>
  );
};

export default Favorites;